export enum ProfileImageType {
  None = 'None',
  User = 'User',
  Restricted = 'Restricted',
  NoPhotoImageInPrivate = 'NoPhotoImageInPrivate',
  NoPhoto = 'NoPhoto',
}
